<template>
    <common-modal v-if="isOpen" width="medium" height="medium" @close="resetValuesAndCloseModal">
        <div class="search-and-add-members">
            <common-content-spacer height="medium">
                <div v-if="selectedUser && !prefillUser" class="search-and-add-members__back" @click="removeSelectedUser">
                    <common-icon name="arrow-left-blue" size="tiny"></common-icon>
                    {{ $t('modals.search_and_add_members.back_to_search') }}
                </div>

                <common-content-wrapper width="small">
                    <common-content-spacer v-if="selectedUser || practice" height="huge">
                        <div class="search-and-add-members__member-container">
                            <practice-member-card
                                v-if="practiceType === PracticeTypeEnum.PHYSICIAN"
                                class="search-and-add-members__member-card"
                                :physician="selectedUser"
                                :isStandalone="true"
                                :showReferralsCount="selectedUser.isInMyNetwork"
                                :showFavorite="false"
                                :isFixedHeight="selectedUser.isInMyNetwork"
                                :showDirectReferralAsInnerModal="true"
                                @added-to-network="userAddedToNetwork"
                            ></practice-member-card>

                            <ancillary-member-card
                                v-if="practiceType === PracticeTypeEnum.ANCILLARY"
                                :ancillary="selectedUser"
                                :showCardAvailability="selectedUser.isInMyNetwork"
                                :showNetworkInclusionStatus="true"
                                :showCardAvailabilityAsInnerModal="true"
                                @checkAvailability="checkAncillaryAvailability($event)"
                                @added-to-network="userAddedToNetwork"
                            ></ancillary-member-card>
                        </div>
                    </common-content-spacer>

                    <invite-sent
                        v-else-if="invitedUserEmail"
                        :email="invitedUserEmail"
                        @close="resetValuesAndCloseModal"
                    ></invite-sent>

                    <common-content-spacer v-else height="medium">
                        <common-page-header
                            :heading="$t('modals.search_and_add_members.heading')"
                            :content="$t('modals.search_and_add_members.content')"
                            :isCenter="true"
                            contentSpacing="large"
                            size="medium"
                        ></common-page-header>

                        <common-user-search-autocomplete
                            :placeholder="$t('modals.search_and_add_members.search_placeholder')"
                            icon="search"
                            iconPosition="right"
                            iconBackground="primary"
                            :practiceType="practiceType"
                            @user-select="userSelected"
                            @no-results="setSearchTerm"
                            @input-change="removeSearchTerm"
                        ></common-user-search-autocomplete>

                        <invite-colleague v-if="searchTerm" :name="searchTerm" @join-invite-sent="inviteSent"></invite-colleague>
                    </common-content-spacer>
                </common-content-wrapper>
            </common-content-spacer>
        </div>
    </common-modal>
</template>

<script>
    import InviteColleague from 'components/page-elements/invites/InviteColleague'
    import CommonUserSearchAutocomplete from 'components/page-elements/search-autocomplete/CommonUserSearchAutocomplete.vue'
    import InviteSent from 'components/page-elements/invites/InviteSent'
    import PracticeMemberCard from 'components/page-elements/practice/PracticeMemberCard'
    import AncillaryMemberCard from 'components/page-elements/practice/AncillaryMemberCard'
    import UsersAPI from 'api/UsersAPI'
    import PracticesAPI from 'api/PracticesAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: { CommonUserSearchAutocomplete, InviteColleague, InviteSent, PracticeMemberCard, AncillaryMemberCard },

        props: {
            isOpen: { type: Boolean, required: true },
            prefillUser: { type: Object, default: null },
            practiceTypeValue: { type: String, default: '' },
        },

        data() {
            return {
                searchTerm: null,
                invitedUserEmail: null,
                selectedUser: null,
                practice: null,
                practiceType: null,
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        methods: {
            userSelected(data) {
                if (data.isPhysician) {
                    UsersAPI.get(data.id, this.$auth.getActiveMember().id).then((res) => {
                        this.selectedUser = res
                    })
                } else {
                    PracticesAPI.getPracticeLocations(data.id).then((locations) => {
                        this.isPageReady = true
                        this.selectedUser = data
                        this.selectedUser.locations = locations.filter((location) => location.isAvailabilitySet)
                        this.selectedUser.locations.forEach((item) => delete item.practiceName)
                    })
                }
            },

            removeSearchTerm() {
                this.searchTerm = null
            },

            setSearchTerm({ searchTerm }) {
                this.searchTerm = searchTerm
            },

            inviteSent({ email }) {
                this.invitedUserEmail = email
                this.emitEvent({ name: 'new-connection-added' })
            },

            removeSelectedUser() {
                this.selectedUser = null
            },

            resetValuesAndCloseModal() {
                this.invitedUserEmail = null
                this.removeSearchTerm()
                this.removeSelectedUser()
                this.emitEvent({ name: 'close' })
            },

            userAddedToNetwork() {
                this.emitEvent({ name: 'new-connection-added' })
                this.selectedUser.isInMyNetwork = true
            },
        },

        watch: {
            practiceTypeValue() {
                this.practiceType = this.practiceTypeValue
            },
        },

        mounted() {
            this.selectedUser = this.prefillUser
            this.practiceType = PracticeTypeEnum.PHYSICIAN
        },
    }
</script>

<style lang="scss">
    .search-and-add-members {
        height: 700px;
        overflow-y: auto;

        &__back {
            color: #13b3e3;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
        }

        &__member-card {
            width: 350px;
            min-height: 480px !important;
        }

        &__member-container {
            display: flex;
            justify-content: center;
        }
    }
</style>
